import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  container: {
    padding: '15px'
  },
  containerItem: {
    borderBottom: '1px solid rgba(0,0,0,0.3)',
    paddingTop: '15px'
  },
  itemKey: {
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '0.3px'
  },
  itemValue: {
    fontSize: '14px'
  }
}));

export default function AddressForm ({ userState }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { userInfo } = userState;
  const hiddenField = ['flowId', 'stepId', 'FaceId', 'searchField', 'type', 'userPhotoPath', 'flow'];
  const schema = Object.entries(userInfo).filter(([field]) => !hiddenField.includes(field));

  return (
    <div className={classes.container}>
      <Typography align='center'>{t('identityListView:biometricAndDocument')}</Typography>
      {schema.map(([ key, value ], i) => (
        value &&
          <div key={i} className={classes.containerItem}>
            <span className={classes.itemKey}>{key}: </span>
            <span className={classes.itemValue}> {value}</span>
          </div>
      )
      )}
    </div>
  );
}
